import { render, staticRenderFns } from "./StaffIndividualLeaveAssignmentPage.vue?vue&type=template&id=34f87d16&scoped=true&"
import script from "./StaffIndividualLeaveAssignmentPage.vue?vue&type=script&lang=js&"
export * from "./StaffIndividualLeaveAssignmentPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34f87d16",
  null
  
)

export default component.exports